import { Box, Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkSelectedActiveColumn } from '../../../utils/market-development';
import Label from './mtpl-labels';
import Spreadsheet from 'react-spreadsheet';
import { toFormatCurrency } from '../../../utils/format';
import useStore from '../../../store';

export default function MtplNew({ labels = [], provinces = [], cells = [] }) {
	const { t } = useTranslation();
	const { currentLang } = useStore((state) => state.currentLang);
	const [active, setActive] = useState(null);

	function totalByRow(rows = []) {
		return rows?.map((row, rowIndex) => {
			const isReadOnly = labels?.[rowIndex]?.readOnly;

			const total = row?.reduce((sum, cell) => {
				const val = String(cell?.value ?? '')
					.replace(/,/g, '')
					.trim();

				if (val === '') return sum;

				const value = Number(val);
				return Number.isFinite(value) ? sum + value : sum;
			}, 0);

			return [
				{
					value: isReadOnly ? '' : toFormatCurrency(total, null),
					readOnly: true,
					className: 'mtpl-total-cell sticky-col-4',
				},
				...row,
			];
		});
	}

	const spreadsheetData = totalByRow(cells);

	return (
		<Box className="mtpl_container">
			<div className={currentLang === 'en' ? 'mtpl_label_head' : 'mtpl_label_head-kh'}>{t('Type of MTPL Insurance')}</div>
			<table className="spreadsheet_custom_header">
				<thead>
					<tr style={{ height: '34px' }}>
						<td className={checkSelectedActiveColumn(active, 0) ? 'active-column sticky-col-4' : 'sticky-col-4 mtpl-label-border'}>{t('Total')}</td>

						{provinces?.map((el, i) => {
							return (
								<td key={i} className={checkSelectedActiveColumn(active, i + 1) ? 'active-column' : 'mtpl_background_silver'}>
									{currentLang === 'en' ? el?.latinName : el?.name}
								</td>
							);
						})}
					</tr>
				</thead>
			</table>

			<div>
				<Flex>
					<Label type="t1" labels={labels} active={active} />
					<Box>
						<Flex alignItems="center" mt="0px" h="0px" borderRight="1px solid hsl(2deg, 0%, 91%)" pl={2} pr={2} />
						<Spreadsheet
							data={spreadsheetData}
							onChange={() => null}
							onActivate={(e) => setActive({ ...e, t: 't1' })}
							hideRowIndicators
							hideColumnIndicators
						/>
					</Box>
				</Flex>
			</div>
		</Box>
	);
}
